import { render } from "./BaseContent.vue?vue&type=template&id=ef423e20&scoped=true"
const script = {}

import "./BaseContent.vue?vue&type=style&index=0&id=ef423e20&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ef423e20"

export default script